import React, { useState, useEffect } from 'react';
import Layout from './../../components/Layout/Layout';
import Paginate from '../../utils/Paginate';
import TransferServices from '../../services/TransferServices';
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import DatePicker from 'react-date-picker';
import { convert, formatDate } from './../../utils/convertDate';


export default function Beneficiaries() {


  const [user, setUsers] = useState([]);
  const [search, setSearch] = useState("")
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [pageLength, setPageLength] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date()
  });
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));

  const listUser = async () => {
    const details = await TransferServices.listBeneficiares(pageIndex, 10, search, fromm, too);
    setUsers([...details.data.result]);
    setPageLength([...details.data.result].length);
    setPageNumber(details.data.totalCount)
    setPageIndex(details.data.pageIndex)
    setPrev(details.data.hasPreviousPage);
    setPage(details.data.totalPages)
    setNextPage(details.data.hasNextPage)
  }

  const searchUser = async (text) => {
       setSearch(text);
  }
  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from)
    setFrom(formValues.from)
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to)
    setToo(convert(toDate));

    const resp = await TransferServices.listBeneficiares(pageIndex, 10, search, convert(newDate), convert(toDate));
    setUsers([...resp.data.result]);
    setPageLength([...resp.data.result].length);
    setPageNumber(resp.data.totalCount);
    setPageIndex(resp.data.pageIndex)
    setPrev(resp.data.hasPreviousPage);
    setPage(resp.data.totalPages)
    setNextPage(resp.data.hasNextPage)
  }
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event })
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event })
    }
  };
  const exportCSV = async () => {
    const resp = await TransferServices.exportBeneficiaries(search, fromm, too);
    window.open(resp.data)
  }
  useEffect(() => {
    listUser();
  }, [pageIndex]);
  return (<>
    <Layout title="Beneficiaries" pageTag={"transfers"} current={'/beneficiaries'}>
      <React.Fragment>
        <main>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
            <div className="px-4 sm:px-6 lg:px-8">
              <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto flex">
                
                  <div className=" relative rounded-md shadow-sm ml-3">
                    <p className='text-sm leading-3 text-gray-500'>From</p>
                    <div>
                      <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                    </div>
                  </div>
                  <div className=" relative rounded-md shadow-sm ml-3">
                    <p className='text-sm leading-3 text-gray-500'>To</p>
                    <div>
                      <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                    </div>
                  </div>
                  <div className='flex ml-4'>
                    <div className="mt-5 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </div>
                      <input
                        type="text"
                        name="user"
                        id="user"
                        onChange={(e) => searchUser(e.target.value)}
                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                        placeholder="Search users"
                      />
                      <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                        <div className='tooltip'>
                          <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                          <span className="tooltiptext"> <p>Search by account number and beneficiary name</p></span>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className='mt-5 ml-4'>
                    <button
                      onClick={range}
                      className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                  </div>
                </div>

                <div className="mt-5  sm:ml-16 sm:flex-none">
                  <button
                    type="button"
                    onClick={exportCSV}
                    className="inline-flex mr-2 items-center hover:text-white active:text-white justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm  sm:w-auto"
                  >
                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                    Export CSV
                  </button>
                </div>
              </div>
              {user.length === 0 ? (
                <div className=" mt-8"> No data available for these dates to show. </div>
              ): 
              <>
              <div className="mt-8 flex flex-col">
                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                      <table className="min-w-full table-fixed divide-y divide-gray-300">
                        <thead>
                          <tr>
                            <th scope="col" className="min-w-[9rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400">
                              Account Name
                            </th>
                            <th scope="col" className="min-w-[9rem] px-2 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Account Number
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Bank name
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Beneficiary Name
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Beneficiary Type
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Customer Username
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Customer Surname
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Customer Firstname
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              Date Created
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">

                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                              <span className="sr-only">Edit</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                          {user.map((person, i) => (
                            <tr key={i} className="bg-gray-50">
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountNumber}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.bankName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.beneficiaryName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.beneficiaryType}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.userName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.userLastName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.userFirstName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateCreated)}</td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
            </>
              }
           

            </div>
          </div>
        </main>

      </React.Fragment>
    </Layout>

  </>);
}